import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@/lib/theme/ThemeProvider";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";
import { shouldIgnoreSentryEvent } from "@/lib/sentry-filter";

Sentry.init({
  enabled: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production",
  dsn: "https://6a79a72396cc00660a03c46a12fc5ea2@o131100.ingest.us.sentry.io/4510747782414336",
  beforeSend(event) {
    return shouldIgnoreSentryEvent(event) ? null : event;
  },
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your index.html'
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
